import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import DetailHeaderWrapper from '../../unified-inbox/components/DetailHeaderWrapper';
import { TOOLBAR_HEIGHT } from '../../constants/Dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BatchColumnHeader = styled(DetailHeaderWrapper).withConfig({
  displayName: "AsyncBatchThreadOperationsToolbarContainerError__BatchColumnHeader",
  componentId: "sc-1rqu6ay-0"
})(["position:absolute;left:-260px;right:0;top:0;padding:0 18px;background:#fff;"]);
const FlexHeader = styled(UIFlex).withConfig({
  displayName: "AsyncBatchThreadOperationsToolbarContainerError__FlexHeader",
  componentId: "sc-1rqu6ay-1"
})(["height:", "px;"], TOOLBAR_HEIGHT);
const AsyncBatchThreadOperationsToolbarContainerError = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(BatchColumnHeader, {
    children: /*#__PURE__*/_jsxs(FlexHeader, {
      align: "center",
      children: [/*#__PURE__*/_jsx("span", {
        className: "is--heading-7 m-y-0 m-right-3",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.title"
        })
      }), /*#__PURE__*/_jsx("span", {
        style: {
          lineHeight: 1.4
        },
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.message"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        size: "xs",
        className: "m-left-2",
        onClick: retry,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.code-splitting.error.button"
        })
      })]
    })
  });
};
AsyncBatchThreadOperationsToolbarContainerError.displayName = 'AsyncBatchThreadOperationsToolbarContainerError';
export default AsyncBatchThreadOperationsToolbarContainerError;